'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'comment';
var width = 512;
var height = 512;
var aliases = [128489,61669];
var unicode = 'f075';
var svgPathData = ['M32 240c0 46.6 16.5 89.8 44.7 124.7l11.9 14.7c-1.7 4.2-12.5 30.7-32.4 79.5l85.9-29.5 11.5-3.9 11.2 4.6c27.8 11.5 58.6 18 91.2 18 125.7 0 224-95 224-208S381.7 32 256 32 32 127 32 240z', 'M88.6 379.4c-1.7 4.2-12.5 30.7-32.4 79.5l85.9-29.5 11.5-3.9 11.2 4.6c27.8 11.5 58.6 18 91.2 18 125.7 0 224-95 224-208S381.7 32 256 32 32 127 32 240c0 46.6 16.5 89.8 44.7 124.7l11.9 14.7zM40.2 498.2L0 512C7.4 493.9 24.7 451.4 51.8 384.8 19.3 344.6 0 294.4 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240 397.4 480 256 480c-36.8 0-71.9-7.3-103.5-20.4L40.2 498.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComment = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;